import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';

/**
 * Updates which element on the surface should be rendered with focus styling
 */
export let updateFocusedSurfaceElement = action('updateFocusedSurfaceElement')(
    function updateFocusedSurfaceElement(newValue: Object, store: CalendarSurfaceStore) {
        if (store.focusedSurfaceElement != newValue) {
            store.focusedSurfaceElement = newValue;
        }
    }
);
